export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: '16px',
  padding: '24px',
  backgroundColor: ({ palette }) => palette.background.paper,
  borderRadius: '8px',
  boxShadow: ({ palette }) => palette.shadow.s,
};

export const headerStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '12px',
};

export const headerActionsStyles = {
  display: 'flex',
  gap: '8px',
  marginLeft: 'auto',
};

export const tablesStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const partyCellStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const partyNameStyles = {
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '4px 8px',
};

export const pendingLabelStyles = {
  flexShrink: 0,
  whiteSpace: 'nowrap',
};

// Contact details are long (emails, addresses); wrap them instead of clipping to an ellipsis.
export const partiesTableStyles = {
  '& .table-cell': {
    whiteSpace: 'normal',
    overflowWrap: 'break-word',
  },
};

// An email has no spaces to wrap at, so let it break anywhere rather than clip.
export const contactEmailStyles = {
  overflowWrap: 'anywhere',
};
